module.exports = __webpack_public_path__ + "static/media/profile_photo.c0f55b8c.jpg";